export const CARRIERS = [
  "DHL Express",
  "Royal Mail",
  "FedEx",
  "UPS",
  "DPD",
  "Yodel",
  "Hermes",
  "TNT Express",
  "Aramex",
  "GLS",
  "Purolator",
  "SF Express",
  "DB Schenker",
  "USPS",
  "Canada Post",
  "Australia Post",
  "Japan Post",
  "La Poste",
  "Correos",
  "PostNL",
  "Deutsche Post",
  "China Post",
  "India Post",
  "EMS",
  "PostNord",
  "SEUR",
  "Chronopost",
  "OnTrac",
  "LaserShip",
  "Blue Dart",
  "Delhivery",
  "Gati",
  "Amazon Logistics",
  "Flipkart Logistics",
  "Alibaba Cainiao",
  "Parcel Force"
] as const;

export type Carrier = (typeof CARRIERS)[number];

export const TRACKING_NUMBER_PLACEHOLDER = "{{ tracking_no }}";

export const DHL_TRACKING_URL = `https://www.dhl.com/gb-en/home/tracking/tracking-express.htm?submit=1&tracking-id=${TRACKING_NUMBER_PLACEHOLDER}`;
export const FEDEX_TRACKING_URL = `https://www.fedex.com/wtrk/track/?trknbr=${TRACKING_NUMBER_PLACEHOLDER}`;
export const ROYAL_MAIL_TRACKING_URL = `https://www.royalmail.com/track-your-item#/tracking-results/${TRACKING_NUMBER_PLACEHOLDER}`;
export const UPS_TRACKING_URL = `https://www.ups.com/track?loc=en_US&tracknum=${TRACKING_NUMBER_PLACEHOLDER}`;
export const YODEL_TRACKING_URL = `https://www.yodel.co.uk/track/${TRACKING_NUMBER_PLACEHOLDER}`;
export const HERMES_TRACKING_URL = `https://www.myhermes.co.uk/track#/parcel/${TRACKING_NUMBER_PLACEHOLDER}`;
export const TNT_TRACKING_URL = `https://www.tnt.com/express/en_gb/site/shipping-tools/tracking.html?searchType=CON&cons=${TRACKING_NUMBER_PLACEHOLDER}`;
export const ARAMEX_TRACKING_URL = `https://www.aramex.com/express/track/results?ShipmentNumber=${TRACKING_NUMBER_PLACEHOLDER}`;
export const GLS_TRACKING_URL = `https://gls-group.com/track?match=${TRACKING_NUMBER_PLACEHOLDER}`;
export const PUROLATOR_TRACKING_URL = `https://www.purolator.com/en/shipping/tracker?pin=${TRACKING_NUMBER_PLACEHOLDER}`;
export const SF_EXPRESS_TRACKING_URL = `https://www.sf-express.com/cn/en/dynamic_function/waybill/#search/bill-number=${TRACKING_NUMBER_PLACEHOLDER}`;
export const DB_SCHENKER_TRACKING_URL = `https://eschenker.dbschenker.com/app/tracking-public/?refNo=${TRACKING_NUMBER_PLACEHOLDER}`;
export const USPS_TRACKING_URL = `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${TRACKING_NUMBER_PLACEHOLDER}`;
export const CANADA_POST_TRACKING_URL = `https://www.canadapost-postescanada.ca/track-reperage/en#/result/${TRACKING_NUMBER_PLACEHOLDER}`;
export const AUSTRALIA_POST_TRACKING_URL = `https://auspost.com.au/mypost/track/#/details/${TRACKING_NUMBER_PLACEHOLDER}`;
export const JAPAN_POST_TRACKING_URL = `https://trackings.post.japanpost.jp/services/srv/search/direct?locale=en&reqCodeNo1=${TRACKING_NUMBER_PLACEHOLDER}`;
export const LA_POSTE_TRACKING_URL = `https://www.laposte.fr/outils/suivre-vos-envois?code=${TRACKING_NUMBER_PLACEHOLDER}`;
export const CORREOS_TRACKING_URL = `https://www.correos.es/es/es/herramientas/localizador/envios/${TRACKING_NUMBER_PLACEHOLDER}`;
export const POSTNL_TRACKING_URL = `https://www.postnl.nl/en/track-and-trace/?bar=${TRACKING_NUMBER_PLACEHOLDER}`;
export const DEUTSCHE_POST_TRACKING_URL = `https://www.deutschepost.de/sendung/simpleQuery.html?lang=en&shipmentNo=${TRACKING_NUMBER_PLACEHOLDER}`;
export const CHINA_POST_TRACKING_URL = `http://track-chinapost.com/result_global.php?tracking_number=${TRACKING_NUMBER_PLACEHOLDER}`;
export const INDIA_POST_TRACKING_URL = `https://www.indiapost.gov.in/VAS/Pages/IndiaPostHome.aspx?Track=${TRACKING_NUMBER_PLACEHOLDER}`;
export const EMS_TRACKING_URL = `https://www.ems.post/tracking/?search=${TRACKING_NUMBER_PLACEHOLDER}`;
export const POSTNORD_TRACKING_URL = `https://www.postnord.se/en/our-tools/track-and-trace?search=${TRACKING_NUMBER_PLACEHOLDER}`;
export const SEUR_TRACKING_URL = `https://www.seur.com/es/localiza-tu-envio.do?tracking=${TRACKING_NUMBER_PLACEHOLDER}`;
export const CHRONOPOST_TRACKING_URL = `https://www.chronopost.fr/en/private/track-your-parcel?search=${TRACKING_NUMBER_PLACEHOLDER}`;
export const ONTRAC_TRACKING_URL = `https://www.ontrac.com/trackingresults.asp?trackingnumber=${TRACKING_NUMBER_PLACEHOLDER}`;
export const LASERSHIP_TRACKING_URL = `https://www.lasership.com/track/${TRACKING_NUMBER_PLACEHOLDER}`;
export const BLUE_DART_TRACKING_URL = `https://www.bluedart.com/tracking?awb=${TRACKING_NUMBER_PLACEHOLDER}`;
export const DELHIVERY_TRACKING_URL = `https://www.delhivery.com/track/package/${TRACKING_NUMBER_PLACEHOLDER}`;
export const GATI_TRACKING_URL = `https://www.gati.com/services/track?docket=${TRACKING_NUMBER_PLACEHOLDER}`;
export const AMAZON_LOGISTICS_TRACKING_URL = `https://www.amazon.com/progress-tracker/package/${TRACKING_NUMBER_PLACEHOLDER}`;
export const FLIPKART_LOGISTICS_TRACKING_URL = `https://www.flipkart.com/track/${TRACKING_NUMBER_PLACEHOLDER}`;
export const ALIBABA_CAINIAO_TRACKING_URL = `https://global.cainiao.com/detail.htm?mailNo=${TRACKING_NUMBER_PLACEHOLDER}`;
export const DPD_TRACKING_URL = `https://www.dpd.com/tracking/${TRACKING_NUMBER_PLACEHOLDER}`;
export const PARCEL_FORCE_TRACKING_URL = `https://www.parcelforce.com/track-trace?trackNumber=${TRACKING_NUMBER_PLACEHOLDER}`;

export const PARCEL_HERO_TRACKING_URL = `https://www.parcelhero.com/en-gb/courier-services/tracking/${TRACKING_NUMBER_PLACEHOLDER}`;

export const CARRIER_TRACKING_URLS: Record<Carrier, string | undefined> = {
  "DHL Express": DHL_TRACKING_URL,
  FedEx: FEDEX_TRACKING_URL,
  "Royal Mail": ROYAL_MAIL_TRACKING_URL,
  UPS: UPS_TRACKING_URL,
  Yodel: YODEL_TRACKING_URL,
  Hermes: HERMES_TRACKING_URL,
  "TNT Express": TNT_TRACKING_URL,
  Aramex: ARAMEX_TRACKING_URL,
  GLS: GLS_TRACKING_URL,
  Purolator: PUROLATOR_TRACKING_URL,
  "SF Express": SF_EXPRESS_TRACKING_URL,
  "DB Schenker": DB_SCHENKER_TRACKING_URL,
  USPS: USPS_TRACKING_URL,
  "Canada Post": CANADA_POST_TRACKING_URL,
  "Australia Post": AUSTRALIA_POST_TRACKING_URL,
  "Japan Post": JAPAN_POST_TRACKING_URL,
  "La Poste": LA_POSTE_TRACKING_URL,
  Correos: CORREOS_TRACKING_URL,
  PostNL: POSTNL_TRACKING_URL,
  "Deutsche Post": DEUTSCHE_POST_TRACKING_URL,
  "China Post": CHINA_POST_TRACKING_URL,
  "India Post": INDIA_POST_TRACKING_URL,
  EMS: EMS_TRACKING_URL,
  PostNord: POSTNORD_TRACKING_URL,
  SEUR: SEUR_TRACKING_URL,
  Chronopost: CHRONOPOST_TRACKING_URL,
  OnTrac: ONTRAC_TRACKING_URL,
  LaserShip: LASERSHIP_TRACKING_URL,
  "Blue Dart": BLUE_DART_TRACKING_URL,
  Delhivery: DELHIVERY_TRACKING_URL,
  Gati: GATI_TRACKING_URL,
  "Amazon Logistics": AMAZON_LOGISTICS_TRACKING_URL,
  "Flipkart Logistics": FLIPKART_LOGISTICS_TRACKING_URL,
  "Alibaba Cainiao": ALIBABA_CAINIAO_TRACKING_URL,
  DPD: DPD_TRACKING_URL,
  "Parcel Force": PARCEL_FORCE_TRACKING_URL
};

export class CarrierHelper {
  static resolveCarrierTrackingURL = (
    trackingNo: string,
    carrier?: string,
    collectionOrder?: boolean
  ): string | undefined => {
    const trackingUrl = CARRIER_TRACKING_URLS[carrier as Carrier];

    if (trackingUrl) {
      return trackingUrl.replace(TRACKING_NUMBER_PLACEHOLDER, trackingNo);
    }

    return collectionOrder ? PARCEL_HERO_TRACKING_URL.replace(TRACKING_NUMBER_PLACEHOLDER, trackingNo) : undefined;
  };
}
